// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ModelsGraphEngineState = {
  GraphEngineStateCreating: 'CREATING',
  GraphEngineStateError: 'ERROR',
  GraphEngineStateRunning: 'RUNNING',
  GraphEngineStateUpdating: 'UPDATING',
  GraphEngineStateDeleted: 'DELETED',
  GraphEngineStateSuspended: 'SUSPENDED',
} as const;
export type ModelsGraphEngineState =
  (typeof ModelsGraphEngineState)[keyof typeof ModelsGraphEngineState];

export function instanceOfModelsGraphEngineState(value: any): boolean {
  for (const key in ModelsGraphEngineState) {
    if (Object.prototype.hasOwnProperty.call(ModelsGraphEngineState, key)) {
      if (
        ModelsGraphEngineState[key as keyof typeof ModelsGraphEngineState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ModelsGraphEngineStateFromJSON(
  json: any,
): ModelsGraphEngineState {
  return ModelsGraphEngineStateFromJSONTyped(json, false);
}

export function ModelsGraphEngineStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelsGraphEngineState {
  return json as ModelsGraphEngineState;
}

export function ModelsGraphEngineStateToJSON(
  value?: ModelsGraphEngineState | null,
): any {
  return value as any;
}

export function ModelsGraphEngineStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ModelsGraphEngineState {
  return value as ModelsGraphEngineState;
}
